import { isImageTransformApplicable } from '../helpers/imageServiceUtils';
import { getImageURI } from '../engines/transforms';
import { getTransform } from './transform';
/**
 * returns image transform uri
 *
 * @param {string}                  fittingType         imageServicesTypes.fittingTypes
 * @param {ImageTransformSource}    src                 source image
 * @param {ImageTransformTarget}    target              target component
 * @param {ImageTransformOptions}   options             transform options
 * @param {Object}                  [transformObj]      transform data object to use
 *
 * @returns {string}
 */
function getURI(fittingType, src, target, options = {}, transformObj) {
    // check if image transformation is applicable (e.g. .gif, .wix_mp)
    if (isImageTransformApplicable(src.id, options?.allowFullGIFTransformation, options?.isPlaceholderFlow)) {
        transformObj =
            transformObj || getTransform(fittingType, src, target, options);
        // set the uri property
        return getImageURI(transformObj);
    }
    return src.id;
}
export { getURI };
//# sourceMappingURL=uri.js.map